import * as React from "react";
import { observer, Provider, inject } from "mobx-react";
import {
  IconButton,
  CircularProgress,
  Avatar,
  Input,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import autobind from "autobind-decorator";
import AccountService from "../../service/AccountService";
import { RouterStore } from "mobx-react-router";
import { observable } from "mobx";
import FileService from "../../service/FileService";
import { Icon } from "@iconify/react";
import robotIcon from "@iconify/icons-mdi/robot";
import SendIcon from "@mui/icons-material/Send";
import firebase from "firebase/compat/app";
import AttachFileRoundedIcon from "@mui/icons-material/AttachFileRounded";
import PhoneInput from "react-phone-input-2";
import { checkEmpty } from "../../util/util";
import { v4 as uuid } from "uuid";
import ChatMessengerService from "../../service/ChatMessengerService";
import ContactService from "../../service/ContactService";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import ChatSpinner from "../../components/chat-spinner/ChatSpinner";
import SendService from "../../service/sendService";
import CustomLinkify from "./components/CustomLinkify";

const Label = styled("label")({
  display: "block",
  marginBottom: "1rem",
});

const Root = styled("div")({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  alignItems: "center",
  width: "300px",
  position: "relative",
});

const LoaderContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  alignItems: "center",
  justifyContent: "center",
});

const TextInput = styled("input")({
  border: "1px solid lightgray",
  outline: "none",
  borderRadius: "4px",
  padding: "4px 12px",
  marginBottom: "4px",
  fontSize: "0.8rem",
  width: "100%",
});
const TextArea = styled("textarea")({
  border: "1px solid lightgray",
  outline: "none",
  borderRadius: "4px",
  padding: "4px 12px",
  marginBottom: "4px",
  fontSize: "0.8rem",
});

const ChatBody = styled("div")({
  paddingTop: "75px",
  paddingBottom: "50px",
});

const CustomHelperTextError = () => (
  <div
    style={{
      color: "red",
      display: "flex",
      alignItems: "center",
      fontSize: "0.8rem",
    }}
  >
    <ErrorOutlineOutlinedIcon style={{ marginRight: "4px" }} />
    <span>This field is required</span>
  </div>
);

type messageType = {
  question: string;
  answer: string;
};

type WebChatProps = {
  routing?: RouterStore;
  account?: AccountService;
  files?: FileService;
  match?: any;
  chatMessenger: ChatMessengerService;
  send: SendService;
};

type WebChatState = {
  username: string;
  message: string;
};

type ChatMessageStatus = "RECIEVE" | "SEND";

type ChatStatus = "LOADING" | "START" | "NORMAL";

@inject("account")
@inject("routing")
@inject("files")
@inject("chatMessenger")
@inject("send")
@observer
export default class WebChatHome extends React.Component<
  WebChatProps,
  WebChatState
> {
  state: WebChatState = {
    username: "",
    message: "",
  };

  private _contactService: ContactService = new ContactService(
    this.props.account
  );

  @observable
  private _messageStatus: ChatMessageStatus = "SEND";
  private _status: ChatStatus = "LOADING";

  @observable
  private _fileName = "";

  @observable
  private _CurrentClinic = {} as any;

  @observable
  private _name = "";

  @observable
  private _qAnswer = "";

  @observable
  private _insetHeight = 0;

  @observable
  private _insetRef: HTMLElement;

  @observable
  messageArray: Array<messageType> = [];

  @observable
  private _formUsername = "";

  @observable
  private _formPhone = "";

  @observable
  private _formMessage = "";

  @observable
  endDialogOpen: boolean = true;

  @observable
  private _userData = {} as any;

  @observable
  private _checkEmptyForm: boolean;

  @observable
  private _showError: boolean;

  @observable
  private _errorMessage: string;

  @observable
  private _successMessage: string;

  @observable
  private _showSuccess: boolean;

  @observable
  private _showSpinner: boolean = false;

  @observable
  private _contactStatus: string = "NORMAL";

  @autobind
  goBack() {
    var { account } = this.props;
    account.goBack();
  }

  @autobind
  handleEditFlow() {
    var { routing } = this.props;
    const { id } = this.props.match.params;
    routing.replace(`/editor/${id}`);
  }

  @autobind
  handleNameChange(ev: any) {
    this._formUsername = ev.target.value;
  }

  @autobind
  handlePhoneChange(val: any) {
    this._formPhone = val;
  }
  @autobind
  handleMessageChange(ev: any) {
    this._formMessage = ev.target.value;
  }

  @autobind
  reload() {
    var { routing } = this.props;
    const { id, userId, clinicId } = this.props.match.params;
    // routing.replace("/blank");
    let link = `/chat/${userId}/${clinicId}/${id}`;

    // setTimeout(() => routing.replace(link));
    routing.replace(link);
  }

  sendSMSHandler = async (event: any) => {
    event.preventDefault();
    this._showError = false;

    let contactData = {
      contactId: uuid(),
      name: this._formUsername.trim(),
      phone: `+${this._formPhone.trim()}`,
      locations: [],
      createdAt: new Date().toString(),
    };
    const state = checkEmpty(contactData);
    if (state) {
      this._checkEmptyForm = true;
    } else {
      const contactResult = await this._contactService.addContact(contactData);
      if (contactResult === "CONTACT_IS_EXIST") {
        this._showError = true;
        this._errorMessage = "Contact already exists";
      } else if (contactResult === "UNKNOWN_ERROR") {
        this._errorMessage = "Error, Please try again later";
        this._showError = true;
      } else {
        this._showSpinner = true;
        this.sendSMSFromChatbot(event);
      }
    }
    this._contactStatus = "NORMAL";
  };

  sendSMSFromChatbot = async (event: any) => {
    event.preventDefault();
    try {
      const phoneNumber = this._userData?.phoneNumber;
      if (phoneNumber) {
        const data = {
          to: phoneNumber,
          body: `
          FlowCharts.ai\n\nFrom : ${this._formUsername}\nphone : +${this._formPhone}\n\n${this._formMessage}
          `,
        };
        const result = await this.props.send.sendSMSFromChatbot(data);
        if (result === "SUCCESS") {
          this._successMessage = "Message sent successfully";
          this._showSuccess = true;
          setTimeout(() => {
            this._showError = false;
          }, 4000);
        } else {
          this._showError = true;
          this._errorMessage = "Something went wrong, please try again later";
        }
      } else {
        this._showError = true;
        this._errorMessage =
          "Please add your phone number to the profile page first.";
      }
      this._showSpinner = false;
    } catch (error) {
      this._showError = true;
      this._errorMessage = "UNKNOWN_ERROR";
      this._showSpinner = false;
    }
  };

  async componentDidMount() {
    const { userId } = this.props.match.params;
    const { routing } = this.props;

    if (userId == null) {
      routing.replace("/");
      return;
    }

    var userDoc = await firebase
      .firestore()
      .collection("userx")
      .doc(userId)
      .get();

    this._userData = (userDoc.data() as any) || {};

    if (this._insetRef != null) {
      this._insetHeight = this._insetRef.offsetHeight;
    }
  }

  componentDidUpdate() {
    let scrollDiv = document.getElementById("scrollDiv");
    scrollDiv.scrollTop = scrollDiv.scrollHeight;
  }

  renderBotComponent(message: any, replyOptions?) {
    return (
      <div
        style={{
          width: "100%",
          padding: "2px 20px",
          paddingLeft: "0",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div
          className="containerWithLink"
          style={{
            backgroundColor: "#E9EEF3",
            borderRadius: "20px 20px 20px 0",
            color: "#5B5D65",
            textAlign: "left",
            alignContent: "center",
            margin: "0px 6px",
            maxWidth: "80%",
            padding: "10px 20px",
            fontSize: "12px",
          }}
        >
          {message}
        </div>
      </div>
    );
  }
  renderBotMessageComponent(message: string, replyOptions?) {
    return (
      <Box
        width="100%"
        padding="2px 20px"
        paddingLeft="0"
        display="flex"
        flexDirection="row"
        alignItems="center"
      >
        <Box
          className="containerWithLink"
          bgcolor="#E9EEF3"
          borderRadius="20px 20px 20px 0"
          color="#5B5D65"
          textAlign="left"
          alignContent="center"
          margin="0px 6px"
          maxWidth="80%"
          padding="10px 20px"
          fontSize="12px"
        >
          <CustomLinkify str={message} />
        </Box>
      </Box>
    );
  }

  renderCustomerMessageComponent(message: any, replyOptions?) {
    return (
      <>
        {message && (
          <Box
            width="100%"
            padding="2px 20px"
            paddingRight="0"
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Box
              bgcolor="#1C8EFF"
              borderRadius="20px 20px 0 20px"
              color="#F9FCFF"
              display="flex"
              textAlign="left"
              alignContent="center"
              padding="10px 20px"
              margin="0px 6px"
              fontSize="12px"
            >
              <CustomLinkify str={message} />
            </Box>
          </Box>
        )}
      </>
    );
  }

  renderQuestionnaireComponent(question: string, answer: string, i: number) {
    return (
      <div key={i}>
        {this.renderBotMessageComponent(question)}
        {/* {this.renderInputMessageComponent(answer)} */}
      </div>
    );
  }

  renderForm() {
    return (
      <div
        style={{
          padding: "1rem",
          backgroundColor: "#fff",
          margin: "1rem 1.5rem",
          borderRadius: "8px",
          boxShadow: "1px 2px 8px lightgrey",
        }}
      >
        <form
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {this._showError && (
            <Typography sx={{ color: "red", margin: "1rem 0" }}>
              {this._errorMessage}
            </Typography>
          )}
          <Label
            htmlFor="username"
            style={{
              marginTop: "1.2rem",
              marginBottom: 0,
            }}
          >
            <Typography fontSize="0.9rem" marginBottom="4px">
              Name
            </Typography>
            <TextInput
              type="text"
              name="username"
              value={this._formUsername}
              onChange={this.handleNameChange}
              disabled={this._contactStatus == "LOADING"}
              placeholder="Name"
            />
            {this._checkEmptyForm && !this._formUsername && (
              <CustomHelperTextError />
            )}
          </Label>
          <Label
            htmlFor="phoneNumber"
            style={{
              marginTop: "1.2rem",
              marginBottom: 0,
            }}
          >
            <Typography fontSize="0.9rem" marginBottom="4px">
              Phone number
            </Typography>
            <PhoneInput
              country={"us"}
              value={this._formPhone}
              onChange={this.handlePhoneChange}
              inputClass="rs-input"
              inputStyle={{
                width: "100%",
                fontSize: "0.8rem",
                outline: "none",
              }}
              dropdownStyle={{ zIndex: "10000000" }}
              placeholder="234 456788"
              disabled={this._contactStatus == "LOADING"}
            />
            {this._checkEmptyForm && !this._formPhone && (
              <CustomHelperTextError />
            )}
          </Label>
          <Label
            htmlFor="message"
            style={{
              marginTop: "1.2rem",
              marginBottom: 0,
            }}
          >
            <Typography fontSize="0.9rem" marginBottom="4px">
              Message
            </Typography>
            <TextArea
              name="message"
              value={this._formMessage}
              onChange={this.handleMessageChange}
              disabled={this._contactStatus == "LOADING"}
              placeholder="Enter your message"
              style={{
                border: "1px solid lightgray",
                outline: "none",
                borderRadius: "4px",
                padding: "4px 12px",
                margin: "10px 0",
                marginBottom: "10px",
                width: "100%",
              }}
              rows={4}
            />
            {this._checkEmptyForm && !this._formMessage && (
              <CustomHelperTextError />
            )}
          </Label>
          <Button
            color="primary"
            variant="contained"
            style={{ margin: "1rem auto 0" }}
            onClick={(ev) => {
              this._contactStatus = "LOADING";
              this.sendSMSHandler(ev);
            }}
            disabled={this._contactStatus == "LOADING"}
          >
            Send
          </Button>
        </form>
      </div>
    );
  }

  handleChange(event: any) {
    this.setState({
      ...this.state,
      [event.target.name]: event.target.value,
    });
  }

  renderLoading() {
    return (
      <LoaderContainer>
        <CircularProgress />
      </LoaderContainer>
    );
  }

  hideChatbot() {
    setTimeout(() => {
      this.endDialogOpen = false;
      window.parent.postMessage({ complete: true }, "*");
    }, 4000);
  }

  render() {
    const { colorSelected } = this.props.match.params;
    return (
      <Root>
        {/* <div
          style={{
            width: "100%",
            height: "env(safe-area-inset-top)",
            backgroundColor: "#3f51b5",
          }}
          ref={(it) => (this._insetRef = it)}
        /> */}
        <div
          id="scrollDiv"
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            overflowY: "scroll",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <Box
            display="flex"
            position="fixed"
            width="100%"
            height="55px"
            padding="0 20px"
            alignItems="center"
            bgcolor={`${colorSelected ? "#" + colorSelected : "#0a65ff"}`}
          >
            {this._userData.displayPic ? (
              <Avatar
                alt="A"
                src={this._userData.displayPic}
                style={{ marginRight: "14px" }}
              ></Avatar>
            ) : (
              <Avatar
                style={{ backgroundColor: "#03a9f4", marginRight: "14px" }}
              >
                <Icon icon={robotIcon} />
              </Avatar>
            )}
            <p style={{ margin: 0, color: "#fff", fontSize: "16px" }}>
              {this._CurrentClinic.name}
            </p>
          </Box>
          <ChatBody>
            {!this._showSuccess &&
              !this._showSpinner &&
              this.renderBotMessageComponent(
                "Enter your information, and our team will text you shortly."
              )}
            {this._showSpinner &&
              !this._showSuccess &&
              this.renderBotComponent(<ChatSpinner />)}
            {!this._showSuccess && !this._showSpinner && this.renderForm()}
            {this._showSuccess && (
              <>
                {this.renderBotMessageComponent(
                  "We got your message. We'll contact you soon"
                )}
                {this.hideChatbot()}
              </>
            )}
          </ChatBody>
        </div>
        <Box
          margin="0"
          bgcolor="#FAFAFA"
          padding="10px 12px"
          width="100%"
          textAlign="center"
          marginBottom="0"
          position="absolute"
          bottom="0"
        >
          <p>
            Chat by{" "}
            <a href="https://flowcharts.ai/" target="_blank">
              FlowCharts.ai
            </a>
          </p>
        </Box>
      </Root>
    );
  }
}
